export const animationOptions = {
  loop: false,
  autoplay: false,
  animationData: null,
  initialSegment: null,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};
